export default __webpack_public_path__ + "static/media/calendar-period.e305cd7d.svg";